import { Col } from '../../components/custom';

export default function SupportTeam()
{
    return (
        <Col id='supportTeam' className='perspectives'>
            <Col className='banner'>
                <span className='title'>Measuring the Impact of Support Team Training on Customer Satisfaction</span>
                <span className='desc'>Did your new training program move the CX needle? Let the data decide.</span>
            </Col>
            <Col className='section'>
                <span className='title'>The Challenge</span>
                <span className='desc bold'>After launching a 2-week training program for first-line support agents focused on soft skills and issue resolution, leadership needed to evaluate its actual impact.</span>
                <span className='descsmall'>While anecdotal feedback suggested better interactions, the organization wanted quantitative evidence: Did the training lead to higher CSAT scores or improved post-interaction sentiment?</span>
            </Col>
            <Col className='section'>
                <span className='title'>Our Philosophy</span>
                <span className='desc bold'>Training effectiveness should be measured by customer outcomes — not just completion rates.</span>
                <span className='descsmall'>We take a data-first approach to enablement evaluation, using structured CX survey data and inferential statistics to isolate and quantify improvement.</span>
            </Col>
            <Col className='section'>
                <span className='title'>The Evaluation Framework</span>
                <span className='desc'>A structured measurement strategy aligned to the support team's customer-facing outcomes:</span>
                <ul>
                    <li className='descsmall'>
                        <strong>Pre-Post CSAT Data Collection</strong>
                        <ul>
                            <li className='descsmall'>Collected CSAT survey responses on a 5-point scale for 4 weeks before and 4 weeks after the training rollout.</li>
                            <li className='descsmall'>Grouped results by agent cohort: trained vs. not-yet-trained.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Statistical Testing with t-Tests</strong>
                        <ul>
                            <li className='descsmall'>Conducted an independent samples t-test comparing pre- and post-training average CSAT scores.</li>
                            <li className='descsmall'>Found a statistically significant increase from <strong>3.85 to 4.23 (p {'<'} 0.01)</strong> in the trained group.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Difference-in-Difference (DiD) Analysis</strong>
                        <ul>
                            <li className='descsmall'>Compared the change in CSAT for the trained cohort vs. an untrained control group.</li>
                            <li className='descsmall'>DiD results showed a net improvement of <strong>+0.28</strong> in the trained group, after adjusting for baseline variation and seasonal shifts.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Open-Text Theme Validation</strong>
                        <ul>
                            <li className='descsmall'>Sentiment analysis of post-interaction feedback highlighted increased mentions of “clarity,” “patience,” and “quick resolution” in the trained cohort.</li>
                            <li className='descsmall'>Negative themes like “confusion” and “unhelpful” dropped by over 30%.</li>
                        </ul>
                    </li>
                </ul>
            </Col>
            <Col className='section'>
                <span className='title'>What This Enables</span>
                <ul>
                    <li className='descsmall'><strong>Clear ROI on Training</strong> — Quantified improvement in CSAT tied directly to the training initiative.</li>
                    <li className='descsmall'><strong>Targeted Expansion</strong> — Enabled L&D to prioritize training rollout to remaining support teams.</li>
                    <li className='descsmall'><strong>Improved Quality Assurance</strong> — Validated that the training improved actual customer-facing behaviors.</li>
                    <li className='descsmall'><strong>Executive Confidence</strong> — Provided leadership with statistical evidence to secure additional enablement budget.</li>
                </ul>
            </Col>
            <Col className='section'>
                <span className='title'>The Takeaway</span>
                <span className='desc bold'>When training works, your customers feel the difference — and the data proves it.</span>
                <span className='descsmall'>By connecting post-interaction CX survey data with statistical analysis, organizations can move from intuition to insight when evaluating training impact.</span>
            </Col>
        </Col>
    )
}